// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.custom-field[data-v-7f343207] {\r\n    display: flex;\r\n    gap: 1rem;\n}\n.text-box[data-v-7f343207] {\r\n    width: 0px;\r\n    flex-grow: 1;\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
